import { Box, Grid } from "@mui/material";
import React, { useMemo } from "react";
import styles from "../PricingDialog.module.scss";

export const Total = React.memo(
  (props: { landAmount: number; houseAmount: number }) => {
    const totalAmount = useMemo(
      () => props.landAmount + props.houseAmount,
      [props.landAmount, props.houseAmount]
    );

    return (
      <Box className={styles.calculate}>
        <Grid container columnSpacing={3} rowSpacing={1} className={styles.row}>
          <Grid
            className={`${styles.column} ${styles.operator}`}
            size={{
              sm: 12,
              md: "grow"
            }}
            sx={{
              display: {
                sm: "none",
                md: "block"
              }
            }}
          ></Grid>
          <Grid
            className={`${styles.column}`}
            size={{
              sm: 12,
              md: "auto"
            }}
          >
            合計： <span className={styles.amount}>{totalAmount}</span>
            万円
          </Grid>
        </Grid>
      </Box>
    );
  }
);
